import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "../Modal";
import { ImportSummoner } from "./ImportSummoner";
import { ImportMatchId } from "./ImportMatchId";
import { closeAllModals } from "../../states/uiStates";
import { ImportGrid } from "@shared/modals/ImportGameModal/grid/ImportGrid";
import { ImportCustomGame } from "@shared/modals/ImportGameModal/ImportCustomGame";
import { useAuth } from "@shared/states/authState";

interface ImportGameModalProps {}

type ImportType = "summoner" | "matchid" | "grid" | "custom"; // "tournamentId"

const UPLOAD_IMPORT_TYPES: ImportType[] = ["grid", "custom"];

const ImportGameModal: React.FC<ImportGameModalProps> = (props) => {
	const [importType, setImportType] = useState<ImportType>("summoner");
	const [queueId, setQueueId] = useState<string>("420");
	const { isAuthenticated } = useAuth();
	const navigate = useNavigate();

	const handleClose = () => {
		closeAllModals();
	};

	const requiresAuth = UPLOAD_IMPORT_TYPES.includes(importType) && !isAuthenticated;

	return (
		<Modal
			onClose={handleClose}
			title={
				<div className={"flex justify-between"}>
					<div>Import Game</div>
					<div className={"text-sm font-light pl-4"}>
						<select
							defaultValue={importType}
							onChange={(e) => setImportType(e.currentTarget.value as ImportType)}
							className={"bg-slate-500 rounded outline-none text-white p-1"}
						>
							<option value={"summoner"}>Ranked</option>
							<option value={"grid"}>GRID</option>
							<option value={"matchid"}>Tournament Realm</option>
							<option value={"custom"}>Custom Game</option>
						</select>
					</div>

					{importType === "summoner" && (
						<div className={"text-sm font-light pl-4"}>
							<select
								defaultValue={queueId}
								onChange={(e) => setQueueId(e.currentTarget.value)}
								className={"bg-slate-500 rounded outline-none text-white p-1"}
							>
								<option value={"420"}>Solo Q</option>
								<option value={"440"}>Flex Q</option>
							</select>
						</div>
					)}
				</div>
			}
		>
			<div>
				{requiresAuth ? (
					<div className={"flex flex-col items-center justify-center gap-4"}>
						<div className={"text-slate-100"}>
							Importing custom games requires signing in.
						</div>
						<button
							className={
								"rounded border border-slate-500 px-2 py-1 text-white hover:bg-slate-600"
							}
							onClick={() => navigate("/login")}
						>
							Sign in
						</button>
					</div>
				) : (
					<>
						{importType === "summoner" && <ImportSummoner queueId={queueId} />}
						{importType === "matchid" && <ImportMatchId />}
						{importType === "grid" && <ImportGrid />}
						{importType === "custom" && <ImportCustomGame />}
					</>
				)}
			</div>
		</Modal>
	);
};

export { ImportGameModal };
